export default __webpack_public_path__ + "static/media/Image-1.ed676656.png";